import { create } from 'zustand';

type State = { hovered: boolean; activeRowCount: number };

const store = create<State>(() => ({ hovered: false, activeRowCount: 0 }));

export const useElementListColumnsHovered = () => store((s) => s.hovered);
export const useAnyRowShowingColumns = () =>
  store((s) => s.hovered || s.activeRowCount > 0);

export const setElementListColumnsHovered = (hovered: boolean) =>
  store.setState({ hovered });

export const incrementActiveRows = () =>
  store.setState((s) => ({ activeRowCount: s.activeRowCount + 1 }));

export const decrementActiveRows = () =>
  store.setState((s) => ({
    activeRowCount: Math.max(0, s.activeRowCount - 1),
  }));
